import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  Form,
} from 'reactstrap';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';


class OFFChecksOkModal extends Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.toggleModal();
  };
  
  render() {
    const { isOpen, toggleModal, cashed, endOpt, ticket} = this.props;

    return (
      <Modal className='modal-offchecks modal-offchecks--ok' isOpen={isOpen} toggle={toggleModal} centered autoFocus>
        <Form onSubmit={this.handleSubmit} autoComplete="off">
          <ModalBody className="py-4">
            <h5 className="modal-title"><FormattedMessage id="offcheck.modal.ok.header" defaultMessage="Cashing OFF-checks" /></h5>
            <p className="form-text bold">
              <FormattedMessage id="offcheck.modal.ok.text.a" defaultMessage="Cashing OFF-checks" />
              {cashed}
              <FormattedMessage id={`offcheck.modal.ok.text.b${endOpt}`} defaultMessage="Cashing OFF-checks" />
              <FormattedMessage id="offcheck.modal.ok.text.c" defaultMessage="Cashing OFF-checks" />
            </p>
            {ticket &&
              <p className="form-text">
                <FormattedMessage id="offcheck.modal.ok.freeticket"
                                  defaultMessage="To participate in the motorcycle drawing and 500,000 rubles, you need to cash the OFF-checks."/>
              </p>
            }
            <Button color="primary" type="submit">
              <FormattedMessage id="main.ok" defaultMessage="Ok" />
            </Button>
          </ModalBody>
        </Form>
      </Modal>
    );
  }
}

export default OFFChecksOkModal;
